import React from 'react'
import { commaSeparetedValue } from '@usap/core'
import { StyledPrice, StyledPriceEmpty } from './InstallAtShopInfo.css'
import useWmoEnabled from '../../../hooks/useWmoEnabled'

type NullableNumber = number | null
type InstallAtShopPriceProps = {
  isRppEnabled: boolean
  installPrice: NullableNumber
  installPriceMin?: NullableNumber
  installPriceMax?: NullableNumber
  page?: 'Cart'
}

const InstallAtShopPrice: React.FC<InstallAtShopPriceProps> = ({
  isRppEnabled, installPrice, installPriceMax, installPriceMin, page,
}) => {
  const priceRpp = `$${commaSeparetedValue(installPriceMin)} - $${commaSeparetedValue(installPriceMax)}`
  const priceRegular = `$${commaSeparetedValue(installPrice)}`

  const isWmoEnabled = useWmoEnabled()
  if (page === 'Cart' && isWmoEnabled) {
    if (isRppEnabled && installPriceMin && installPriceMax) {
      return <span>{`${priceRpp} *`}</span>
    }
    if (installPrice) {
      return <span>{`${priceRegular} *`}</span>
    }
    return <span>-</span>
  }

  if (isRppEnabled && installPriceMin && installPriceMax) {
    return (
      <StyledPrice>
        {priceRpp}
      </StyledPrice>
    )
  }

  if (installPrice) {
    return (
      <StyledPrice>
        {priceRegular}
      </StyledPrice>
    )
  }

  return <StyledPriceEmpty>-</StyledPriceEmpty>
}

export default InstallAtShopPrice
